module.exports = __webpack_public_path__ + "img/page-bg.26844cfc.webp";